export default "__VITE_PUBLIC_ASSET__c51547af__"